import type { ScheduleDefaultsType } from './schedule-defaults';

export function getScheduleSettings<T extends ScheduleDefaultsType>({
  scheduleStart,
  scheduleEnd,
  scheduleIsAllDay,
  scheduleTimeZone,
  scheduleRepeatPeriod,
  scheduleRepeatFrequency,
  scheduleRepeatInterval,
  scheduleRepeatWeeklyOnDays,
  scheduleRepeatMonthlyOnDay,
  scheduleRepeatEnds,
  scheduleRepeatEndsDate,
  scheduleRepeatEndsOccurrences
}: T): ScheduleDefaultsType {
  return {
    scheduleStart,
    scheduleEnd,
    scheduleIsAllDay,
    scheduleTimeZone,
    scheduleRepeatPeriod,
    scheduleRepeatFrequency,
    scheduleRepeatInterval,
    scheduleRepeatWeeklyOnDays,
    scheduleRepeatMonthlyOnDay,
    scheduleRepeatEnds,
    scheduleRepeatEndsDate,
    scheduleRepeatEndsOccurrences
  };
}
